import { getCurrentOrg } from "#webapp/src/util/org.util";
import { useQuery } from "@apollo/client";
import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import { HomeNavTeamsDocument } from "@clockwise/web-commons/src/ui/home-nav/__generated__/HomeNavTeams.generated";
import { Skeleton } from "@material-ui/lab";
import React from "react";
import { ReactElement } from "react-markdown/lib/react-markdown";
import { getSortedCollatedTeamInfo } from "../web-settings/web-settings";
import { AppNavLinkMenuItem } from "./AppNavLinkMenu";

const byTeamName = (a: Team, b: Team) => a.teamName.localeCompare(b.teamName);

type Team = {
  teamId: string;
  teamName: string;
};

type AppNavTeamLinksProps = {
  teams: Team[];
  loading?: boolean;
  icon: ReactElement;
};

export const useTeamsList = (): [Team[], boolean] => {
  const { data, loading } = useQuery(HomeNavTeamsDocument);
  const viewer = getValue(data?.viewer, "Viewer");
  const org = getCurrentOrg(viewer);

  const teamsList = org ? getSortedCollatedTeamInfo(org) : [];

  return [teamsList, loading];
};

export const AppNavTeamLinks = ({ icon, teams, loading = false }: AppNavTeamLinksProps) => {
  if (loading) {
    return (
      <div className="cw-flex cw-flex-col cw-space-y-1 cw-px-3">
        <Skeleton className="cw-rounded" variant="rect" height={20} />
        <Skeleton className="cw-rounded" variant="rect" height={20} />
      </div>
    );
  }

  return teams.sort(byTeamName).map(({ teamId, teamName }) => {
    return (
      <AppNavLinkMenuItem key={teamId} to={`/app/team/${teamId}`} icon={icon} label={teamName} />
    );
  });
};
